/**
 * 系统管理-软件权限创建
 * @author xingzb
 * @date 2020-02-14
 */
import request from "@/utils/request";

export function getResourceTree(query) {
  return request({
    url: `/ntocc-basic-api/resource/tree`,
    method: "get",
    params: query
  });
}
// 获取托运人tree
export function getResourceShipmentTree(query) {
  return request({
    url: `/ntocc-basic-api/resource/shipmentTree`,
    method: "get",
    params: query
  });
}
export function addResourceTree(query) {
  return request({
    url: `/ntocc-basic-api/resource`,
    method: "post",
    params: query
  });
}
export function updateResourceTree(query) {
  return request({
    url: `/ntocc-basic-api/resource`,
    method: "put",
    params: query
  });
}
export function delResourceTree(query) {
  return request({
    url: `/ntocc-basic-api/resource`,
    method: "delete",
    params: query
  });
}
export function getRoleResourceTree(query) {
  return request({
    url: `/ntocc-basic-api/role/resourceCodeList`,
    method: "get",
    params: query
  });
}
export function updateRoleResourceTree(data) {
  return request({
    url: `/ntocc-basic-api/role/updateRoleResource`,
    method: "put",
    data
  });
}
// 审核手机号
export function changePasswdPhoneAudit(data) {
  return request({
    url: `/ntocc-basic-api/changePasswdPhoneAudit/audit`,
    method: "put",
    params: data
  });
}
